
import { defineComponent } from "vue";
import router from "@/router";
import {
  GetMetricData,
  GetMetric,
  SummaryTitleByMonth,
  NumberWithCommas,
  GetHighlight,
  ChangeOverTime,
  SourceURL,
  GetDateFromMonthYear,
  GetMoneyFormat,
} from "@/utils";
import Spinner from "@/components/Spinner.vue";
import LineChart from "@/components/Chart/LineChart.vue";
import FilterTabs from "@/components/Chart/FilterTabs.vue";
import MetricTitle from "@/components/MetricTitle.vue";
import SectionTitle from "@/components/SectionTitle.vue";
import MetricGrid from "@/components/MetricGrid.vue";
import MetricStat from "@/components/MetricStat.vue";
import MetricSource from "@/components/MetricSource.vue";
import MetricHighlight from "@/components/MetricHighlight.vue";
import ChartOptions from "@/types/chartOptions";

export default defineComponent({
  data() {
    return {
      data: [],
      selectedData: [],
      metric: {},
      summaryDate: new Date(),
      latestNumbers: "",
      monthChange: "",
      monthChangePercent: "",
      yearChange: "",
      yearChangePercent: "",
      highlight: "",
      filterOptions: [1, 5, 10, 0],

      //Chart setup
      options: new ChartOptions(),
      dataLabels: ["Dollars Per Barrrel"],
      dataProps: ["oil_price_per_barrel"],
    };
  },
  components: {
    Spinner,
    LineChart,
    MetricTitle,
    SectionTitle,
    FilterTabs,
    MetricGrid,
    MetricStat,
    MetricSource,
    MetricHighlight,
  },
  methods: {
    debug(e: any) {
      console.log("debug", e);
    },
    handleFilter(option: any) {
      this.limitData(option);
    },
    limitData(years: number) {
      /* This is going to be custom for each metric, you need to cin some cases 
        convert the lable to a date. Then limit the date to the intended range */
      if (years == 0) {
        this.selectedData = this.data;
      } else {
        let count = -1 * (12 * years);
        this.selectedData = this.data.slice(count);
      }
    },
    summaryTitle() {
      return SummaryTitleByMonth(this.summaryDate);
    },
    sourceUrl() {
      return SourceURL(this.metric);
    },
  },
  async beforeMount() {
    //@ts-ignore
    const topic = router.currentRoute.value.name; // Get which metric by the route
    this.data = await GetMetricData(topic); // Get raw data from Socrata
    this.metric = GetMetric(topic); // Get metric configuration
    this.selectedData = this.data; // initialize this to "lifetime" and update this variable when a range is selected

    //Add custom chart options
    this.options.scales.yAxis.ticks.callback = (label: any) => {
      return "$ " + Number(label).toFixed(2);
    };

    // Get summary data and hightlights
    const lastItem: any = this.data[this.data.length - 1];
    this.summaryDate = GetDateFromMonthYear(lastItem.date);
    this.latestNumbers = GetMoneyFormat(lastItem.oil_price_per_barrel);
    this.monthChange = GetMoneyFormat(
      ChangeOverTime(this.data, 1, "oil_price_per_barrel", false)
    );
    this.monthChangePercent = ChangeOverTime(
      this.data,
      1,
      "oil_price_per_barrel",
      true
    );
    this.yearChange = GetMoneyFormat(
      ChangeOverTime(this.data, 12, "oil_price_per_barrel", false)
    );
    this.yearChangePercent = ChangeOverTime(
      this.data,
      12,
      "oil_price_per_barrel",
      true
    );
    this.highlight = GetHighlight(this.data);
  },
});
